import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { PaypalCancelComponent } from './paypal-cancel.component';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('registration.paypal-cancel', {
            url: '/paypal-cancel',
            data: {
                authorisationLevel: 0,
                pageTitle: 'Registration Paypal'
            },
            'views': {
                'multiContentRegistration': {
                    template: '<paypal-cancel flex="100"></paypal-cancel>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const PaypalCancelModule: string = ng
    .module('paypal-cancel', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('paypalCancel', PaypalCancelComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/paypal-cancel/paypal-cancel.module.ts